export var OddWidth;
(function (OddWidth) {
    OddWidth[OddWidth["S"] = 48] = "S";
    OddWidth[OddWidth["M"] = 68] = "M";
    OddWidth[OddWidth["L"] = 104] = "L";
})(OddWidth || (OddWidth = {}));
